export class EquipmentDetails {
  public constructor(
    public equipmentNumber: string,
    public equipmentCategory: string,
    public equipmentDescription: string,
    public equipmentStatus: string,
    public equipmentType: string,
    public equipmentTypeText: string,
    public weightOfObject: number,
    public unitOfWeight: string,
    public aquisitionValue: number,
    public currencyKey: string,
    public manufacturer: string,
    public manufacturerSerialNumber: string,
    public maintenancePlant: string,
    public maintenancePlantText: string,
    public location: string,
    public locationtext: string,
    public room: string,
    public controllingArea: string,
    public costCenter: string,
    public costCenterShortName: string,
    public costCenterLongName: string,
    public wbsElement: string,
    public wbsElementDescription: string,
    public settlementOrder: string,
    public maintenancePlanningPlant: string,
    public maintenancePlanningPlantText: string,
    public plannerGroup: string,
    public plannerGroupText: string,
    public superOrdinateEquipment: string,
    public constructionId: string,
    public designId: string,
    public mainiGroupId: string,
    public mainGroupDescription: string,
    public receivingPlant: string,
    public receivingPlantText: string,
    public statusCode: string,
    public cleaningInterval: string,
    public lastCleaning: string,
    public budgetShots: string,
    public actualNumberOfElements: string,
    public oldMachineNumber: string,
    public mouldBudgetYear: string,
    public mouldBoxInclInPrice: string,
    public additionalLocation: string,
    public cleaningWeek: string,
    public sysCleaningPct: string,
    public SPPH: string,
    public objectNumber: string,
    public changeTime: string
  ) {}
}
